import React from 'react'
import img2 from "../../Assets/Banner/DashBanner/Dash2.jpg"

function DashBanner() {
  return (
    <div>
      <img src={img2} alt="" className='h-[300px] w-full object-cover'/>
    </div>
  )
}

export default DashBanner
